import { render, staticRenderFns } from "./ManualEnroll.vue?vue&type=template&id=4b8c97cf&scoped=true&"
import script from "./ManualEnroll.vue?vue&type=script&lang=js&"
export * from "./ManualEnroll.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ManualEnroll.vue?vue&type=style&index=1&id=4b8c97cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c97cf",
  null
  
)

export default component.exports